import { render, staticRenderFns } from "./instanceDekaprime.vue?vue&type=template&id=6ef31ac6&scoped=true"
import script from "./instanceDekaprime.vue?vue&type=script&lang=js"
export * from "./instanceDekaprime.vue?vue&type=script&lang=js"
import style0 from "./instanceDekaprime.vue?vue&type=style&index=0&id=6ef31ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef31ac6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VDataTable,VIcon,VList,VListItem,VListItemTitle,VRow,VTooltip})
